/**
 * Constants for Rig Calibration module
 */

// Bucket density thresholds
export const BUCKET_THRESHOLDS = {
  LOW_MAX: 9.5,
  MID_MAX: 12.5,
} as const;

// Bucket names
export const BUCKET_NAMES = {
  LOW: 'LOW',
  MID: 'MID',
  HIGH: 'HIGH',
} as const;

// Bucket colors for UI
export const BUCKET_COLORS = {
  LOW: 'cyan',
  MID: 'blue',
  HIGH: 'violet',
} as const;

// Validation limits for calibration values
// Calibration factors can be negative (e.g., -50 to +50)
export const VALIDATION_LIMITS = {
  MIN_VALUE: -100,  // Minimum calibration value (can be negative)
  MAX_VALUE: 100,   // Maximum calibration value
  MAX_SUM: 100,     // Maximum sum of Oil% + Water% for a bucket
} as const;

// Percentage limits for retort history (Oil%, Water%)
// Percentages cannot be negative (0-100 only)
export const PERCENTAGE_LIMITS = {
  MIN: 0,    // Minimum percentage (cannot be negative)
  MAX: 100,  // Maximum percentage
} as const;

// Pagination
export const TEST_RESULTS_PER_PAGE = 10;

// Calibration slots are not sample-source definitions. Source names and
// mappings come from the backend sample-source catalog.
export const CALIBRATION_SLOTS = [
  { key: 'active' },
  { key: 'ls_effluent' },
  { key: 'ls_return' },
  { key: 'hs_effluent' },
  { key: 'hs_discard' },
  { key: 'drying_shaker_discard' },
  { key: 'drying_effluent' },
  { key: 'new_mud' },
  { key: 'random' },
] as const;

// Default calibration values
export const DEFAULT_CALIBRATION_VALUES = {
  active_oil_calibration: 0,
  active_water_calibration: 0,
  ls_effluent_oil_calibration: 0,
  ls_effluent_water_calibration: 0,
  ls_return_oil_calibration: 0,
  ls_return_water_calibration: 0,
  hs_effluent_oil_calibration: 0,
  hs_effluent_water_calibration: 0,
  hs_discard_oil_calibration: 0,
  hs_discard_water_calibration: 0,
  drying_shaker_discard_oil_calibration: 0,
  drying_shaker_discard_water_calibration: 0,
  drying_effluent_oil_calibration: 0,
  drying_effluent_water_calibration: 0,
  new_mud_oil_calibration: 0,
  new_mud_water_calibration: 0,
  random_oil_calibration: 0,
  random_water_calibration: 0,
} as const;

// API error messages
export const API_ERROR_MESSAGES = {
  UNAUTHORIZED: 'Unauthorized. Please log in again.',
  ACCESS_DENIED: 'Access denied. Please contact your administrator.',
  RIG_NOT_FOUND: 'Rig not found',
  CALIBRATION_NOT_FOUND: 'Calibration not found',
  SAVE_FAILED: 'Failed to save calibration',
  LOAD_FAILED: 'Failed to load calibration',
} as const;
